import cx from "@hsl/core/utils/cx";

const BASE_STYLES = [
    "text-sm",
    "sm:text-base",
    "[&>*]:text-sm",
    "[&>*]:sm:text-base",
];

const UNORDERED_LIST_STYLES = [
    "[&_ul]:pl-4",
    "[&_ul>li::marker]:text-bullet",
    "[&_ul>li::marker]:text-xl",
    "[&_ul>li::marker]:text-dark-yellow",
    "[&_ul>li]:!list-disc",
    "[&_ul>li]:my-1",
    "[&_ul>li]:sm:my-2",
    "[&_ul>li>strong]:!font-medium",
    "[&>ul>li>strong]:!block",
    "[&_ul:not(:last-child)]:mb-2",
    "[&_ul:not(:last-child)]:sm:mb-4",
];

const ORDERED_LIST_STYLES = [
    "[&_ol]:pl-4",
    "[&_ol]:list-decimal",
    "[&_ol:not(:last-child)]:mb-2",
    "[&_ol:not(:last-child)]:sm:mb-4",
];

const HEADER_STYLES = [
    "[&_h1]:text-lg",
    "[&_h1]:font-medium",
    "[&_h2]:text-lg",
    "[&_h2]:font-medium",
    "[&_h3]:mb-2",
    "[&_h3]:text-lg",
    "[&_h3]:font-medium",
    "[&_h3]:text-charcoal",
];

const PARAGRAPH_STYLES = ["[&>p:not(:last-child)]:mb-2", "[&>p]:text-charcoal"];

const ANCHOR_STYLES = [
    "[&_a]:!text-core-blue",
    "[&_a:hover]:underline",
    "[&_a]:break-all",
];

const SERPENTINE_STYLES = [
    "[&_.serp-non-breaking]:!bg-inherit",
    "[&_.serp-non-breaking]:!whitespace-nowrap",
];

interface Props {
    className?: string;
    data?: string;
}

const TextDataPart = ({ className, data }: Props) => {
    if (!data) {
        return null;
    }
    return (
        <div
            className={cx(
                BASE_STYLES,
                UNORDERED_LIST_STYLES,
                ORDERED_LIST_STYLES,
                HEADER_STYLES,
                ANCHOR_STYLES,
                PARAGRAPH_STYLES,
                SERPENTINE_STYLES,
                className,
            )}
            dangerouslySetInnerHTML={{ __html: data }}
        />
    );
};

export default TextDataPart;
